import CustomPage from "@/views/correspondence/components/list";
export default {
  name: "correspondence-history",
  components: {
    CustomPage: CustomPage
  }
};